import React  from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

function redirecter (redirectLocation) {
  location.href = `/signin?dest=${encodeURIComponent(redirectLocation)}`;
}

export function requireAuth (Component) {
  class AuthContainer extends React.Component {
    componentWillMount () {
      this.verifyAuth(this.props.accessToken);
    }

    componentWillReceiveProps (nextProps) {
      this.verifyAuth(nextProps.accessToken);
    }

    verifyAuth (accessToken) {
      if (!accessToken) {
        const { location } = this.props;
        const redirectLocation = `${location.pathname}${location.search}`;

        redirecter(redirectLocation);
      }
    }

    render () {
      return (
        <div>
          <Component {...this.props} />
        </div>
      );
    }
  }

  AuthContainer.propTypes = {
    accessToken: PropTypes.string,
    location: PropTypes.object.isRequired
  };

  const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken
  });

  return connect(mapStateToProps)(AuthContainer);
}
